export default __webpack_public_path__ + "media/images/partners/McGill_logoT-584ff0fc0c40616756efd5be2852af2b.gif";